// extracted by mini-css-extract-plugin
var _1 = "TopicViewHeader-module__ancestorsContainer--v_s04";
var _2 = "TopicViewHeader-module__animateUploadProgressBarWidth--mWlxx";
var _3 = "TopicViewHeader-module__animatedBackground--HNNM_";
var _4 = "TopicViewHeader-module__caret--tDPPR";
var _5 = "TopicViewHeader-module__content--Xu1fM";
var _6 = "TopicViewHeader-module__controls--ugN9r";
var _7 = "TopicViewHeader-module__description--o5E4K";
var _8 = "TopicViewHeader-module__hasBanner--b5aHc";
var _9 = "TopicViewHeader-module__inPlaceEditControls--hjFsI";
var _a = "TopicViewHeader-module__isEditing--R2VXL";
var _b = "TopicViewHeader-module__isSidebarOpen--Yn6dG";
var _c = "TopicViewHeader-module__overflownControls--_u9xk";
var _d = "TopicViewHeader-module__separator--JuaiR";
var _e = "TopicViewHeader-module__title--HrtHK";
export { _1 as "ancestorsContainer", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "caret", _5 as "content", _6 as "controls", _7 as "description", _8 as "hasBanner", _9 as "inPlaceEditControls", _a as "isEditing", _b as "isSidebarOpen", _c as "overflownControls", _d as "separator", _e as "title" }
